import React from "react";
import { GoPlusCircle } from "react-icons/go";
import useTitanApp from "../../../../../../../hooks/useTitanApp";
import { Skeleton } from "@mui/material";
import {
  setCurrentShowAddAllergiessModal,
  setCurrentPatientAllergyToEdit,
  setCurrentPatientAllergyToDelete,
} from "../../../../../../../dispatchers/patientDispatchers";
import { LuHeart } from "react-icons/lu";
import { MdOutlineEdit } from "react-icons/md";
import { FaRegTrashAlt } from "react-icons/fa";

export default function PatientAllergies() {
  const { appState, patientState } = useTitanApp();
  const { darkMode } = appState || {};
  const { patientAllergies, patientAllergiesLoading, isConsultationEnabled } =
    patientState || {};

  const handleEditClick = async (allergy) => {
    setCurrentShowAddAllergiessModal(true);
    setCurrentPatientAllergyToEdit(allergy);
  };
  const handleDeleteClick = async (allergy) => {
    setCurrentPatientAllergyToDelete(allergy);
  };

  return (
    <div className="patient-items-wrapper">
      <div className="header-title">
        <h6>Allergies</h6>
        <div
          className="add-vital-btn"
          onClick={() => {
            if (!isConsultationEnabled) {
              setCurrentShowAddAllergiessModal(true);
            }
          }}
        >
          <GoPlusCircle />
          <p>Add Allergies</p>
        </div>
      </div>
      <div className="list-items vitals-list">
        {patientAllergiesLoading
          ? Array.from({ length: 5 }).map((_, index) => (
              <div key={index} className="list-item sk">
                <Skeleton
                  width={150}
                  height={50}
                  animation="wave"
                  sx={{ bgcolor: darkMode ? "grey.800" : "" }}
                />
                <Skeleton
                  width={200}
                  height={30}
                  animation="wave"
                  sx={{ bgcolor: darkMode ? "grey.800" : "" }}
                />
              </div>
            ))
          : patientAllergies?.map((allergy, index) => (
              <div className="pc-leftpanel-list-item" key={index}>
                <div className="d-flex">
                  <div className="first">
                    <div className="icon-box">
                      <LuHeart color={darkMode ? "#bdbdbd" : "#0a0a0a"} />
                    </div>

                    <div className="vital-details">
                      <p>{allergy?.allergyName}</p>
                      <p>{allergy?.typicalReaction}</p>
                    </div>
                  </div>
                  <div className="type">
                    <p
                      style={{
                        backgroundColor:
                          allergy?.severity === 1
                            ? "#dcfce7"
                            : allergy?.severity === 2
                            ? "#ffedd5"
                            : allergy?.severity === 3
                            ? "#fee2e2"
                            : "",
                        color:
                          allergy?.severity === 1
                            ? "#829079"
                            : allergy?.severity === 2
                            ? "#c2410c"
                            : allergy?.severity === 3
                            ? "#b91c1c"
                            : "",
                      }}
                    >
                      {allergy?.severity === 1
                        ? "Mild"
                        : allergy?.severity === 2
                        ? "Moderate"
                        : allergy?.severity === 3
                        ? "Severe"
                        : ""}
                    </p>
                  </div>
                </div>
                <div className="a-actions">
                  <MdOutlineEdit
                    color="grey"
                    size={20}
                    className="icons-pointer pc-action-icons"
                    onClick={() => handleEditClick(allergy)}
                  />
                  <FaRegTrashAlt
                    color="red"
                    size={15}
                    className=" icons-pointer pc-action-icons"
                    onClick={() => handleDeleteClick(allergy)}
                  />
                </div>
              </div>
            ))}
      </div>
    </div>
  );
}
